import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {ButtonBase, Menu, MenuItemLink, Stack, Typography} from 'views/components';
import {PersonOutline, KeyboardArrowRight} from 'views/icons';
import {Translate} from 'views/module';

const NavbarUser = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const user = props.user;
  const clientData = props.clientData;

  const clientName = clientData?.careplan?.generalInformation?.clientName;

  const menuOpen = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonBase
        id="navbar-user-button"
        aria-controls={menuOpen ? 'navbar-user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleOpen}
        sx={{
          'minWidth': '248px',
          'width': '100%',
          'alignItems': 'center',
          'justifyContent': 'space-between',
          'backgroundColor': 'white',
          'borderRadius': '12px',
          'p': 2,
          'display': 'flex',
          'textAlign': 'left',
          'transition': 'background-color 0.2s ease-in-out',
          '&:hover': {
          },
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <PersonOutline
            sx={{
              height: '2.75rem',
              width: '2.75rem',
              borderRadius: '50%',
              backgroundColor: 'navbar.main',
              p: 0.5,
            }}
          />
          <Stack spacing="0.125rem">
            <Typography
              sx={{
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '1.0rem',
                lineHeight: '150%',
                letterSpacing: 0,
                color: 'navbar.text',
              }}
            >
              {user.firstName} {user.lastName}
            </Typography>
            {
              clientName &&
              <Typography
                sx={{
                  fontWeight: 400,
                  fontStyle: 'normal',
                  fontSize: '0.75rem',
                  lineHeight: '136%',
                  letterSpacing: 0,
                  color: '#2D2925A3',
                }}
              >
                <Translate expression={'navbar.CareFor'} substitute={{clientName}} />
              </Typography>
            }
          </Stack>
        </Stack>
        <KeyboardArrowRight
          sx={{
            height: '2.0rem',
            width: '2.0rem',
            color: 'navbar.text',
            transition: 'transform 0.2s ease-in-out',
            transform: menuOpen ? 'rotate(180deg)' : 'none',
          }}
        />
      </ButtonBase>
      <Menu
        id="navbar-user-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          list: {
            'aria-labelledby': 'navbar-user-button',
          },
          paper: {
            sx: {
              borderRadius: 2,
              width: anchorEl?.offsetWidth,
              minWidth: anchorEl?.offsetWidth,
            },
          },
        }}
      >
        <MenuItemLink
          href="/signout"
          onClick={handleClose}
          sx={{
            fontWeight: 700,
            fontSize: '1.0rem',
          }}
        >
          <Translate expression={'navbar.SignOut'} />
        </MenuItemLink>
      </Menu>
    </>
  );
};
NavbarUser.propTypes = {
  user: PropTypes.object.isRequired,
  clientData: PropTypes.object,
};
const mapStateToProps = (state) => ({
  user: state.user,
  clientData: state.clientData,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarUser));
